module.exports = __webpack_public_path__ + "static/media/fullstack2.167ee432.png";